var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlocks = function SvgBlocks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 78,
    fill: "none",
    viewBox: "0 0 78 78"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 47.188,
    height: 37.188,
    x: 15.406,
    y: 20.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#blocks_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#blocks_svg__b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__c)",
    d: "M26 34.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C29.04 28 30.16 28 32.4 28h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C52 31.04 52 32.16 52 34.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C48.96 44 47.84 44 45.6 44H32.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C26 40.96 26 39.84 26 37.6z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 0.375,
    d: "M32.4 28.188h13.2c1.123 0 1.954 0 2.612.053.655.054 1.121.16 1.518.363a3.8 3.8 0 0 1 1.667 1.666c.202.396.308.863.362 1.518.053.658.053 1.49.053 2.612v3.2c0 1.123 0 1.954-.053 2.612-.054.655-.16 1.121-.362 1.518a3.8 3.8 0 0 1-1.666 1.667c-.398.202-.864.308-1.52.362-.657.053-1.488.053-2.611.053H32.4c-1.123 0-1.954 0-2.612-.053-.655-.054-1.122-.16-1.518-.362a3.8 3.8 0 0 1-1.666-1.666c-.203-.398-.31-.864-.363-1.52-.053-.657-.053-1.488-.053-2.611v-3.2c0-1.123 0-1.954.053-2.612.054-.655.16-1.122.363-1.518a3.8 3.8 0 0 1 1.666-1.666c.396-.203.863-.31 1.518-.363.658-.053 1.49-.053 2.612-.053Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 47.188,
    height: 37.188,
    x: 0.406,
    y: 0.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#blocks_svg__d)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#blocks_svg__e)",
    shapeRendering: "crispEdges"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__f)",
    fillOpacity: 0.5,
    d: "M11 14.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C14.04 8 15.16 8 17.4 8h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C37 11.04 37 12.16 37 14.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C33.96 24 32.84 24 30.6 24H17.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C11 20.96 11 19.84 11 17.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__g)",
    fillOpacity: 0.25,
    d: "M11 14.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C14.04 8 15.16 8 17.4 8h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C37 11.04 37 12.16 37 14.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C33.96 24 32.84 24 30.6 24H17.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C11 20.96 11 19.84 11 17.6z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M17.4 8.5h13.2c1.128 0 1.945 0 2.587.053.636.052 1.056.153 1.402.329a3.5 3.5 0 0 1 1.53 1.53c.175.345.276.765.328 1.401.053.642.053 1.459.053 2.587v3.2c0 1.128 0 1.945-.053 2.586-.052.637-.153 1.057-.329 1.403a3.5 3.5 0 0 1-1.53 1.53c-.345.175-.765.276-1.401.328-.642.053-1.459.053-2.587.053H17.4c-1.128 0-1.945 0-2.586-.053-.637-.052-1.057-.153-1.403-.329a3.5 3.5 0 0 1-1.53-1.53c-.175-.345-.276-.765-.328-1.402-.053-.641-.053-1.458-.053-2.586v-3.2c0-1.128 0-1.945.053-2.587.052-.636.153-1.056.329-1.402a3.5 3.5 0 0 1 1.53-1.53c.345-.175.765-.276 1.401-.328.642-.053 1.459-.053 2.587-.053Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 47.188,
    height: 37.188,
    x: 30.406,
    y: 0.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#blocks_svg__h)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#blocks_svg__i)",
    shapeRendering: "crispEdges"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__j)",
    fillOpacity: 0.5,
    d: "M41 14.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C44.04 8 45.16 8 47.4 8h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C67 11.04 67 12.16 67 14.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C63.96 24 62.84 24 60.6 24H47.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C41 20.96 41 19.84 41 17.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__k)",
    fillOpacity: 0.25,
    d: "M41 14.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C44.04 8 45.16 8 47.4 8h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C67 11.04 67 12.16 67 14.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C63.96 24 62.84 24 60.6 24H47.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C41 20.96 41 19.84 41 17.6z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M47.4 8.5h13.2c1.128 0 1.945 0 2.587.053.636.052 1.056.153 1.402.329a3.5 3.5 0 0 1 1.53 1.53c.175.345.276.765.328 1.401.053.642.053 1.459.053 2.587v3.2c0 1.128 0 1.945-.053 2.586-.052.637-.153 1.057-.329 1.403a3.5 3.5 0 0 1-1.53 1.53c-.345.175-.765.276-1.401.328-.642.053-1.459.053-2.587.053H47.4c-1.128 0-1.945 0-2.587-.053-.636-.052-1.056-.153-1.402-.329a3.5 3.5 0 0 1-1.53-1.53c-.175-.345-.276-.765-.328-1.402-.053-.641-.053-1.458-.053-2.586v-3.2c0-1.128 0-1.945.053-2.587.052-.636.153-1.056.329-1.402a3.5 3.5 0 0 1 1.53-1.53c.345-.175.765-.276 1.401-.328.642-.053 1.459-.053 2.587-.053Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 47.188,
    height: 37.188,
    x: 30.406,
    y: 40.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#blocks_svg__l)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#blocks_svg__m)",
    shapeRendering: "crispEdges"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__n)",
    fillOpacity: 0.5,
    d: "M67 54.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C63.96 48 62.84 48 60.6 48H47.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C41 51.04 41 52.16 41 54.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C44.04 64 45.16 64 47.4 64h13.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C67 60.96 67 59.84 67 57.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__o)",
    fillOpacity: 0.25,
    d: "M67 54.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C63.96 48 62.84 48 60.6 48H47.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C41 51.04 41 52.16 41 54.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C44.04 64 45.16 64 47.4 64h13.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C67 60.96 67 59.84 67 57.6z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M60.6 48.5H47.4c-1.128 0-1.945 0-2.587.053-.636.052-1.056.153-1.402.329a3.5 3.5 0 0 0-1.53 1.53c-.175.345-.276.765-.328 1.401-.053.642-.053 1.459-.053 2.587v3.2c0 1.128 0 1.945.053 2.587.052.636.153 1.056.329 1.402a3.5 3.5 0 0 0 1.53 1.53c.345.175.765.276 1.401.328.642.053 1.459.053 2.587.053h13.2c1.128 0 1.945 0 2.587-.053.636-.052 1.056-.153 1.402-.329a3.5 3.5 0 0 0 1.53-1.53c.175-.345.276-.765.328-1.401.053-.642.053-1.459.053-2.587v-3.2c0-1.128 0-1.945-.053-2.587-.052-.636-.153-1.056-.329-1.402a3.5 3.5 0 0 0-1.53-1.53c-.345-.175-.765-.276-1.401-.328-.642-.053-1.459-.053-2.587-.053Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 47.188,
    height: 37.188,
    x: 0.406,
    y: 40.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#blocks_svg__p)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#blocks_svg__q)",
    shapeRendering: "crispEdges"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__r)",
    fillOpacity: 0.5,
    d: "M37 54.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C33.96 48 32.84 48 30.6 48H17.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C11 51.04 11 52.16 11 54.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C14.04 64 15.16 64 17.4 64h13.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C37 60.96 37 59.84 37 57.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__s)",
    fillOpacity: 0.25,
    d: "M37 54.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C33.96 48 32.84 48 30.6 48H17.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C11 51.04 11 52.16 11 54.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C14.04 64 15.16 64 17.4 64h13.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C37 60.96 37 59.84 37 57.6z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M30.6 48.5H17.4c-1.128 0-1.945 0-2.586.053-.637.052-1.057.153-1.403.329a3.5 3.5 0 0 0-1.53 1.53c-.175.345-.276.765-.328 1.401-.053.642-.053 1.459-.053 2.587v3.2c0 1.128 0 1.945.053 2.587.052.636.153 1.056.329 1.402a3.5 3.5 0 0 0 1.53 1.53c.345.175.765.276 1.401.328.642.053 1.459.053 2.587.053h13.2c1.128 0 1.945 0 2.587-.053.636-.052 1.056-.153 1.402-.329a3.5 3.5 0 0 0 1.53-1.53c.175-.345.276-.765.328-1.401.053-.642.053-1.459.053-2.587v-3.2c0-1.128 0-1.945-.053-2.587-.052-.636-.153-1.056-.329-1.402a3.5 3.5 0 0 0-1.53-1.53c-.345-.175-.765-.276-1.401-.328-.642-.053-1.459-.053-2.587-.053Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 32.188,
    height: 37.188,
    x: 45.406,
    y: 20.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#blocks_svg__t)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#blocks_svg__u)",
    shapeRendering: "crispEdges"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__v)",
    fillOpacity: 0.5,
    d: "M67 33.5c0-1.396 0-2.093-.172-2.661a4 4 0 0 0-2.667-2.667C63.593 28 62.896 28 61.5 28s-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C56 31.407 56 32.104 56 33.5v5c0 1.396 0 2.093.172 2.661a4 4 0 0 0 2.667 2.667C59.407 44 60.104 44 61.5 44s2.093 0 2.661-.172a4 4 0 0 0 2.667-2.667C67 40.593 67 39.896 67 38.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__w)",
    fillOpacity: 0.25,
    d: "M67 33.5c0-1.396 0-2.093-.172-2.661a4 4 0 0 0-2.667-2.667C63.593 28 62.896 28 61.5 28s-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C56 31.407 56 32.104 56 33.5v5c0 1.396 0 2.093.172 2.661a4 4 0 0 0 2.667 2.667C59.407 44 60.104 44 61.5 44s2.093 0 2.661-.172a4 4 0 0 0 2.667-2.667C67 40.593 67 39.896 67 38.5z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M61.5 28.5c-1.431 0-2.037.005-2.516.15a3.5 3.5 0 0 0-2.334 2.334c-.145.48-.15 1.084-.15 2.516v5c0 1.431.005 2.037.15 2.516a3.5 3.5 0 0 0 2.334 2.334c.48.145 1.084.15 2.516.15s2.037-.005 2.516-.15a3.5 3.5 0 0 0 2.334-2.334c.145-.48.15-1.084.15-2.516v-5c0-1.431-.005-2.037-.15-2.516a3.5 3.5 0 0 0-2.334-2.334c-.48-.145-1.085-.15-2.516-.15Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 32.188,
    height: 37.188,
    x: 0.406,
    y: 20.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#blocks_svg__x)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#blocks_svg__y)",
    shapeRendering: "crispEdges"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__z)",
    fillOpacity: 0.5,
    d: "M22 33.5c0-1.396 0-2.093-.172-2.661a4 4 0 0 0-2.667-2.667C18.593 28 17.896 28 16.5 28s-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C11 31.407 11 32.104 11 33.5v5c0 1.396 0 2.093.172 2.661a4 4 0 0 0 2.667 2.667C14.407 44 15.104 44 16.5 44s2.093 0 2.661-.172a4 4 0 0 0 2.667-2.667C22 40.593 22 39.896 22 38.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#blocks_svg__A)",
    fillOpacity: 0.25,
    d: "M22 33.5c0-1.396 0-2.093-.172-2.661a4 4 0 0 0-2.667-2.667C18.593 28 17.896 28 16.5 28s-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C11 31.407 11 32.104 11 33.5v5c0 1.396 0 2.093.172 2.661a4 4 0 0 0 2.667 2.667C14.407 44 15.104 44 16.5 44s2.093 0 2.661-.172a4 4 0 0 0 2.667-2.667C22 40.593 22 39.896 22 38.5z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M16.5 28.5c-1.431 0-2.037.005-2.516.15a3.5 3.5 0 0 0-2.334 2.334c-.145.48-.15 1.084-.15 2.516v5c0 1.431.005 2.037.15 2.516a3.5 3.5 0 0 0 2.334 2.334c.48.145 1.085.15 2.516.15s2.037-.005 2.516-.15a3.5 3.5 0 0 0 2.334-2.334c.145-.48.15-1.084.15-2.516v-5c0-1.431-.005-2.037-.15-2.516a3.5 3.5 0 0 0-2.334-2.334c-.48-.145-1.084-.15-2.516-.15Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blocks_svg__c",
    x1: 39.813,
    x2: 39.813,
    y1: 28.235,
    y2: 54.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blocks_svg__f",
    x1: 24,
    x2: 24,
    y1: 15.1,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blocks_svg__j",
    x1: 54,
    x2: 54,
    y1: 15.1,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blocks_svg__n",
    x1: 54,
    x2: 54,
    y1: 55.1,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blocks_svg__r",
    x1: 24,
    x2: 24,
    y1: 55.1,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blocks_svg__v",
    x1: 61.5,
    x2: 61.5,
    y1: 35.1,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blocks_svg__z",
    x1: 16.5,
    x2: 16.5,
    y1: 35.1,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "blocks_svg__a",
    transform: "translate(-15.406 -20.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 34.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C29.04 28 30.16 28 32.4 28h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C52 31.04 52 32.16 52 34.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C48.96 44 47.84 44 45.6 44H32.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C26 40.96 26 39.84 26 37.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "blocks_svg__d",
    transform: "translate(-.406 -.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 14.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C14.04 8 15.16 8 17.4 8h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C37 11.04 37 12.16 37 14.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C33.96 24 32.84 24 30.6 24H17.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C11 20.96 11 19.84 11 17.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "blocks_svg__h",
    transform: "translate(-30.406 -.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 14.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C44.04 8 45.16 8 47.4 8h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C67 11.04 67 12.16 67 14.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C63.96 24 62.84 24 60.6 24H47.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C41 20.96 41 19.84 41 17.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "blocks_svg__l",
    transform: "translate(-30.406 -40.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67 54.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C63.96 48 62.84 48 60.6 48H47.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C41 51.04 41 52.16 41 54.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C44.04 64 45.16 64 47.4 64h13.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C67 60.96 67 59.84 67 57.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "blocks_svg__p",
    transform: "translate(-.406 -40.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 54.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C33.96 48 32.84 48 30.6 48H17.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C11 51.04 11 52.16 11 54.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C14.04 64 15.16 64 17.4 64h13.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C37 60.96 37 59.84 37 57.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "blocks_svg__t",
    transform: "translate(-45.406 -20.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67 33.5c0-1.396 0-2.093-.172-2.661a4 4 0 0 0-2.667-2.667C63.593 28 62.896 28 61.5 28s-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C56 31.407 56 32.104 56 33.5v5c0 1.396 0 2.093.172 2.661a4 4 0 0 0 2.667 2.667C59.407 44 60.104 44 61.5 44s2.093 0 2.661-.172a4 4 0 0 0 2.667-2.667C67 40.593 67 39.896 67 38.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "blocks_svg__x",
    transform: "translate(-.406 -20.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 33.5c0-1.396 0-2.093-.172-2.661a4 4 0 0 0-2.667-2.667C18.593 28 17.896 28 16.5 28s-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C11 31.407 11 32.104 11 33.5v5c0 1.396 0 2.093.172 2.661a4 4 0 0 0 2.667 2.667C14.407 44 15.104 44 16.5 44s2.093 0 2.661-.172a4 4 0 0 0 2.667-2.667C22 40.593 22 39.896 22 38.5z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blocks_svg__b",
    width: 47.188,
    height: 37.188,
    x: 15.406,
    y: 20.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_7017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_7017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blocks_svg__e",
    width: 47.188,
    height: 37.188,
    x: 0.406,
    y: 0.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_7017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_7017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blocks_svg__i",
    width: 47.188,
    height: 37.188,
    x: 30.406,
    y: 0.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_7017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_7017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blocks_svg__m",
    width: 47.188,
    height: 37.188,
    x: 30.406,
    y: 40.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_7017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_7017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blocks_svg__q",
    width: 47.188,
    height: 37.188,
    x: 0.406,
    y: 40.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_7017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_7017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blocks_svg__u",
    width: 32.188,
    height: 37.188,
    x: 45.406,
    y: 20.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_7017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_7017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blocks_svg__y",
    width: 32.188,
    height: 37.188,
    x: 0.406,
    y: 20.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_7017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_7017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "blocks_svg__g",
    width: 2.462,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#blocks_svg__B",
    transform: "scale(.0024 .0039)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "blocks_svg__k",
    width: 2.462,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#blocks_svg__B",
    transform: "scale(.0024 .0039)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "blocks_svg__o",
    width: 2.462,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#blocks_svg__B",
    transform: "scale(.0024 .0039)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "blocks_svg__s",
    width: 2.462,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#blocks_svg__B",
    transform: "scale(.0024 .0039)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "blocks_svg__w",
    width: 5.818,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#blocks_svg__B",
    transform: "scale(.00568 .0039)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "blocks_svg__A",
    width: 5.818,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#blocks_svg__B",
    transform: "scale(.00568 .0039)"
  })))));
};
export default SvgBlocks;